import { LocationState } from './types';
import { Action, createReducer, on } from '@ngrx/store';
import { ClearLocationAction, ClearSearchResultsAction, SetLocFiltersAction, SetLocationAction, SetSearchLocationResultsAction } from './location.actions';

export const initialState: LocationState = {
  errors: [],
  LocationData: null,
  searchResults: null,
  searchFilters: []
};

export function LocationReducer(state: any = initialState, action: Action) {
  return reducer(state, action);
}

export const reducer = createReducer(
  initialState,
  on(
    SetLocationAction,
    (state, { selectedLocation }) =>
      ({
        ...state,
        LocationData: selectedLocation,
      } as LocationState)
  ),
  on(
    SetSearchLocationResultsAction,
    (state, { searchResults }) => ({
        ...state,
        searchResults
    } as LocationState)
  ),
  on(
      SetLocFiltersAction,
      (state, { searchFilters }) => ({
          ...state,
          searchFilters
      } as LocationState)
  ),
  on(
      ClearSearchResultsAction,
      (state) => ({
          ...state,
          searchResults: initialState.searchResults
      } as LocationState)
  ),
  on(ClearLocationAction, (state) => initialState)
);
